import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.dot)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "option-dot-line",
        title: _ctx.option.name
      }, [
        _createVNode(_component_v_icon, {
          size: "x-small",
          color: _ctx.option.color,
          class: "option-dot"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.VALUE_DOT), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        _createTextVNode(_toDisplayString(_ctx.option.name), 1)
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass(["option-chip-text", _ctx.tintClasses(_ctx.option.color)]),
        title: _ctx.option.name
      }, _toDisplayString(_ctx.option.name), 11, _hoisted_2))
}